import { render, staticRenderFns } from "./QuickmailBuy.vue?vue&type=template&id=64f1cb54&scoped=true&"
import script from "./QuickmailBuy.vue?vue&type=script&lang=js&"
export * from "./QuickmailBuy.vue?vue&type=script&lang=js&"
import style0 from "./QuickmailBuy.vue?vue&type=style&index=0&id=64f1cb54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f1cb54",
  null
  
)

export default component.exports